import _defineProperty from "/home/javi/repos/infomerc/tasa-collectum/ecommerce/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../defaultTheme";
import FormLabel from "../FormLabel";
import ChevronDown from "../icons/ChevronDown";
import FormFeedback from "../FormFeedback";
import TYPE_OPTIONS from "../FormFeedback/consts";
import SIZE_OPTIONS from "./consts";
import { right, left, rtlSpacing } from "../utils/rtl";
import getSpacingToken from "../common/getSpacingToken";
import getFieldDataState from "../common/getFieldDataState";

var getSelectSize = function getSelectSize(_ref2) {
  var _tokens;

  var theme = _ref2.theme,
      size = _ref2.size;
  var tokens = (_tokens = {}, _defineProperty(_tokens, SIZE_OPTIONS.SMALL, theme.orbit.heightInputSmall), _defineProperty(_tokens, SIZE_OPTIONS.NORMAL, theme.orbit.heightInputNormal), _tokens);
  return tokens[size];
};

var Label = styled.label.withConfig({
  displayName: "Select__Label",
  componentId: "sc-6agypz-0"
})(["position:relative;display:block;width:100%;margin-bottom:", ";"], getSpacingToken);
Label.defaultProps = {
  theme: defaultTheme
};
var StyledSelect = styled( // $FlowExpected
React.forwardRef(function (_ref3, ref) {
  var className = _ref3.className,
      dataTest = _ref3.dataTest,
      children = _ref3.children,
      value = _ref3.value,
      disabled = _ref3.disabled,
      name = _ref3.name,
      error = _ref3.error,
      tabIndex = _ref3.tabIndex,
      onChange = _ref3.onChange,
      onFocus = _ref3.onFocus,
      onBlur = _ref3.onBlur,
      id = _ref3.id;
  return React.createElement("select", {
    id: id,
    "data-test": dataTest,
    "data-state": getFieldDataState(error),
    value: value,
    className: className,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    disabled: disabled,
    name: name,
    tabIndex: tabIndex,
    ref: ref
  }, children);
})).withConfig({
  displayName: "Select__StyledSelect",
  componentId: "sc-6agypz-1"
})(["appearance:none;background:", ";border-radius:", ";cursor:pointer;color:", ";font-family:", ";font-size:", ";height:", ";padding:", ";outline:none;width:100%;transition:box-shadow ", " ease-in-out;z-index:2;color:", ";> option{color:", ";}&::-ms-expand{display:none;}&::-ms-value{background:transparent;color:", ";color:", ";}border:0;box-shadow:inset 0 0 0 ", ";&:hover{box-shadow:inset 0 0 0 ", ";}&:focus{box-shadow:inset 0 0 0 ", ";}&:disabled{color:", ";background:", ";cursor:not-allowed;&:hover{box-shadow:inset 0 0 0 1px ", ";}}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.backgroundInput;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.orbit.borderRadiusNormal;
}, function (_ref6) {
  var theme = _ref6.theme,
      filled = _ref6.filled;
  return filled ? theme.orbit.colorTextInput : theme.orbit.colorPlaceholderInput;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.orbit.fontFamily;
}, function (_ref8) {
  var theme = _ref8.theme,
      size = _ref8.size;
  return size === SIZE_OPTIONS.SMALL ? theme.orbit.fontSizeInputSmall : theme.orbit.fontSizeInputNormal;
}, getSelectSize, function (_ref9) {
  var theme = _ref9.theme,
      size = _ref9.size,
      prefix = _ref9.prefix;
  return rtlSpacing(size === SIZE_OPTIONS.SMALL && !prefix && "0 ".concat(theme.orbit.spaceXLarge, " 0 ").concat(theme.orbit.spaceSmall) || size === SIZE_OPTIONS.SMALL && prefix && "0 ".concat(theme.orbit.spaceXLarge, " 0 ").concat(theme.orbit.paddingLeftSelectPrefix) || prefix && "0 ".concat(theme.orbit.spaceXXLarge, " 0 ").concat(theme.orbit.paddingLeftSelectPrefix) || "0 ".concat(theme.orbit.spaceXXLarge, " 0 ").concat(theme.orbit.spaceSmall));
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.orbit.durationFast;
}, function (_ref11) {
  var customValueText = _ref11.customValueText;
  return customValueText && "transparent";
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.orbit.colorTextInput;
}, function (_ref13) {
  var theme = _ref13.theme,
      filled = _ref13.filled;
  return filled ? theme.orbit.colorTextInput : theme.orbit.colorPlaceholderInput;
}, function (_ref14) {
  var customValueText = _ref14.customValueText;
  return customValueText && "rgba(255, 255, 255, 0)";
}, function (_ref15) {
  var theme = _ref15.theme,
      error = _ref15.error;
  return "".concat(theme.orbit.borderWidthInput, " ").concat(error ? theme.orbit.borderColorInputError : theme.orbit.borderColorInput);
}, function (_ref16) {
  var theme = _ref16.theme,
      error = _ref16.error;
  return "".concat(theme.orbit.borderWidthInput, " ").concat(error ? theme.orbit.borderColorInputErrorHover : theme.orbit.borderColorInputHover);
}, function (_ref17) {
  var theme = _ref17.theme;
  return "".concat(theme.orbit.borderWidthInputFocus, " ").concat(theme.orbit.borderColorInputFocus);
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.orbit.colorTextInputDisabled;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.orbit.backgroundInputDisabled;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.orbit.borderColorInput;
});
StyledSelect.defaultProps = {
  theme: defaultTheme
};
export var SelectContainer = styled(function (_ref21) {
  var className = _ref21.className,
      children = _ref21.children;
  return React.createElement("div", {
    className: className
  }, children);
}).withConfig({
  displayName: "Select__SelectContainer",
  componentId: "sc-6agypz-2"
})(["position:relative;display:flex;align-items:center;background:", ";width:100%;box-sizing:border-box;cursor:pointer;"], function (_ref22) {
  var theme = _ref22.theme;
  return theme.orbit.backgroundInput;
});
SelectContainer.defaultProps = {
  theme: defaultTheme
};
var SelectPrefix = styled(function (_ref23) {
  var className = _ref23.className,
      children = _ref23.children;
  return React.createElement("div", {
    className: className
  }, children);
}).withConfig({
  displayName: "Select__SelectPrefix",
  componentId: "sc-6agypz-3"
})(["display:flex;align-items:center;position:absolute;padding:", ";pointer-events:none;z-index:3;top:0;height:", ";"], function (_ref24) {
  var theme = _ref24.theme;
  return "0 ".concat(theme.orbit.spaceSmall);
}, getSelectSize);
SelectPrefix.defaultProps = {
  theme: defaultTheme
};
var SelectSuffix = styled(function (_ref25) {
  var children = _ref25.children,
      className = _ref25.className;
  return React.createElement("div", {
    className: className
  }, children);
}).withConfig({
  displayName: "Select__SelectSuffix",
  componentId: "sc-6agypz-4"
})(["position:absolute;display:flex;justify-content:center;align-items:center;top:0;", ":", ";color:", ";pointer-events:none;z-index:3;height:100%;& > *{width:", ";height:", ";margin-bottom:", ";}"], right, function (_ref26) {
  var theme = _ref26.theme;
  return theme.orbit.spaceXSmall;
}, function (_ref27) {
  var theme = _ref27.theme,
      disabled = _ref27.disabled;
  return disabled ? theme.orbit.colorTextInputDisabled : theme.orbit.colorTextInput;
}, function (_ref28) {
  var theme = _ref28.theme,
      size = _ref28.size;
  return size === SIZE_OPTIONS.SMALL && theme.orbit.widthIconSmall;
}, function (_ref29) {
  var theme = _ref29.theme,
      size = _ref29.size;
  return size === SIZE_OPTIONS.SMALL && theme.orbit.heightIconSmall;
}, function (_ref30) {
  var size = _ref30.size,
      theme = _ref30.theme;
  return size === SIZE_OPTIONS.SMALL && theme.orbit.spaceXXXSmall;
});
SelectSuffix.defaultProps = {
  theme: defaultTheme
};
var StyledCustomValue = styled(function (_ref) {
  var prefix = _ref.prefix,
      theme = _ref.theme,
      size = _ref.size,
      filled = _ref.filled,
      props = _objectWithoutProperties(_ref, ["prefix", "theme", "size", "filled"]);

  return React.createElement("div", props);
}).withConfig({
  displayName: "Select__StyledCustomValue",
  componentId: "sc-6agypz-5"
})(["color:", ";font-family:", ";font-size:", ";z-index:3;position:absolute;height:100%;line-height:", ";top:0;", ":", ";bottom:0;pointer-events:none;"], function (_ref31) {
  var theme = _ref31.theme,
      filled = _ref31.filled;
  return filled ? theme.orbit.colorTextInput : theme.orbit.colorPlaceholderInput;
}, function (_ref32) {
  var theme = _ref32.theme;
  return theme.orbit.fontFamily;
}, function (_ref33) {
  var theme = _ref33.theme,
      size = _ref33.size;
  return size === SIZE_OPTIONS.SMALL ? theme.orbit.fontSizeInputSmall : theme.orbit.fontSizeInputNormal;
}, getSelectSize, left, function (_ref34) {
  var prefix = _ref34.prefix,
      theme = _ref34.theme;
  return prefix ? "48px" : theme.orbit.spaceSmall;
});
StyledCustomValue.defaultProps = {
  theme: defaultTheme
}; // $FlowExpected

var Select = React.forwardRef(function (props, ref) {
  var _props$size = props.size,
      size = _props$size === void 0 ? SIZE_OPTIONS.NORMAL : _props$size,
      label = props.label,
      placeholder = props.placeholder,
      value = props.value,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      error = props.error,
      help = props.help,
      name = props.name,
      onChange = props.onChange,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      options = props.options,
      tabIndex = props.tabIndex,
      id = props.id,
      required = props.required,
      dataTest = props.dataTest,
      prefix = props.prefix,
      spaceAfter = props.spaceAfter,
      customValueText = props.customValueText;
  var filled = !(value == null || value === "");
  return React.createElement(Label, {
    spaceAfter: spaceAfter
  }, label && React.createElement(FormLabel, {
    filled: filled,
    disabled: disabled,
    required: required
  }, label), React.createElement(SelectContainer, {
    disabled: disabled
  }, prefix && React.createElement(SelectPrefix, {
    prefix: prefix,
    size: size
  }, prefix), customValueText && React.createElement(StyledCustomValue, {
    filled: filled,
    size: size,
    prefix: prefix
  }, customValueText), React.createElement(StyledSelect, {
    dataTest: dataTest,
    size: size,
    disabled: disabled,
    error: error,
    value: value == null ? "" : value,
    prefix: prefix,
    name: name,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onChange,
    filled: filled,
    customValueText: customValueText,
    tabIndex: tabIndex,
    id: id,
    required: required,
    ref: ref
  }, placeholder && React.createElement("option", {
    label: placeholder,
    value: ""
  }, placeholder), options.map(function (option) {
    return React.createElement("option", {
      key: "option-".concat(option.value),
      value: option.value,
      disabled: option.disabled
    }, option.label);
  })), React.createElement(SelectSuffix, {
    size: size,
    disabled: disabled
  }, React.createElement(ChevronDown, null))), help && !error && React.createElement(FormFeedback, {
    type: TYPE_OPTIONS.HELP
  }, help), error && React.createElement(FormFeedback, {
    type: TYPE_OPTIONS.ERROR
  }, error));
}); // otherwise Unknown in storybook

Select.displayName = "Select";
export default Select;